//  ----------      START   IMPORT  BLOCK       ----------
//  Widgets
import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
//  Utils
import { pick_color } from '../../../../../Utils/colorUtils.jsx'
import { transformedDate } from '../../../../../Utils/dateUtils.jsx';
//  ----------      START   IMPORT  BLOCK       ----------


const TagDisplay = ({ diagnose, tag, name, handleOpenInHistory }) => {
  // Extract properties from the data object
  const { creation_date, _id, diagnosis, tags_contained } = diagnose;

  const handleClick = () => {
    handleOpenInHistory(_id);
  };

  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id={`tooltip-${tag}`}>{transformedDate(creation_date)}</Tooltip>}
    >
      <Badge 
      pill 
      bg={pick_color(tag)}
        style={{ backgroundColor: pick_color(tag), cursor: 'pointer', color: '#fff' }} // Ensure text color is white for visibility
        onClick={handleClick}
      >
        {name}
      </Badge>
    </OverlayTrigger>
  );
};

export default TagDisplay;